export const environment = {
    apiUrl: 'https://as-georgestore-stg-gje3gmc6c8cad9g3.mexicocentral-01.azurewebsites.net/api',
};
